import { Link } from 'react-router-dom'
import { useTranslation, Trans } from 'react-i18next'

const ConsentCheckbox = ({ className = "text-gray-500" }) => {
    const { t } = useTranslation()

    return (
        <div className={`space-y-4 text-xs ${className}`}>
            <label className="flex items-start gap-3 cursor-pointer group">
                <input type="checkbox" className="mt-1 form-checkbox text-primary border-gray-300 rounded focus:ring-primary" />
                <span className="leading-relaxed">
                    <Trans
                        i18nKey="consent.checkbox_1_text"
                        components={{
                            1: <strong className="font-bold" />,
                            3: <strong className="font-bold" />,
                            5: <strong className="font-bold" />,
                            7: <strong className="font-bold" />,
                            9: <a href="mailto:info@jdrivero.com" className="underline hover:text-primary" />,
                            11: <strong className="font-bold" />,
                            13: <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer" className="underline hover:text-primary" />,
                            15: <strong className="font-bold" />,
                            17: <strong className="font-bold" />
                        }}
                    />
                </span>
            </label>

            <label className="flex items-start gap-3 cursor-pointer group">
                <input type="checkbox" className="mt-1 form-checkbox text-primary border-gray-300 rounded focus:ring-primary" />
                <span>
                    <Trans
                        i18nKey="consent.checkbox_2_text"
                        components={{
                            1: <Link to="/terms-of-service" target="_blank" rel="noopener noreferrer" className="underline hover:text-primary font-bold" />,
                            3: <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer" className="underline hover:text-primary font-bold" />
                        }}
                    />
                </span>
            </label>
        </div>
    )
}

export default ConsentCheckbox
